/**
 *  @function eacaprHtml 转义html脚本 < > & " ' / `
 *  @param value-
 *                          字符串
 */
export function eacaprHtml(value) {
  if(typeof value !== 'string') {
     return value
  }
  return value.replace(/[&<>`"'\/*]/g,function(result){
    return {
      '&':'&amp;',
      '<':'&lt;',
      '>':'&gt;',
      '`':'&#x60;',
      '"':'&quot;',
     "'":'&#x27;',
     '/':'&#x2f',
     '%':'&#37;',
     '=':'&#61;',
	 '*':'&#42;',
    }[result]
 })
}

export function eacaprHtmlGoods(value) {
  if(typeof value !== 'string') {
     return value
  }
  return value.replace(/[&<>`"'\/*]/g,function(result){
    return {
      '&':'',
      '<':'&lt;',
      '>':'&gt;',
      '`':'&#x60;',
      '"':'&quot;',
	  "'":'',
	  '/':'',
	 '*':'&#42;',
    }[result]
 })
}
/**
 *  @function htmlspecialchars 转义html脚本方案2 < > & " ' / `
 *  @param str-
 *                          字符串
 */
export function htmlspecialchars(str) {       
  var s = "";  
  if (str.length == 0) return "";  
  for   (var i=0; i<str.length; i++)  
  {  
      switch (str.substr(i,1))  
      {  
          case "<": s += "&lt;"; break;  
          case ">": s += "&gt;"; break;  
          case "&": s += "&amp;"; break;  
          case " ":  
              if(str.substr(i + 1, 1) == " "){  
                  s += " &nbsp;";  
                  i++;  
              } else s += " ";  
              break;  
          case "\"": s += "&quot;"; break;  
          case "\n": s += "<br>"; break;  
          default: s += str.substr(i,1); break;  
      }  
  }  
  return s;  
}

// function encodeHtml(html){
//   return html && html.replace ? 
//     (
//       html.replace(/&/g, "&amp;") //转换&符号
//       .replace(/ /g, "&nbsp;") // 转换空格
//       .replace(/\b&nbsp;+/g, " ") // 转换多个空格为单个空格
//       .replace(/</g, "&lt;") // 转换小于符号
//       .replace(/>/g, "&gt;") // 转换大于符号
//       .replace(/\\/g, "&#92;") // 转换斜杠符号
//       .replace(/\'/g, "&#39;") // 转换单引号
//       .replace(/\"/g, "&quot;") // 转换双引号
//       .replace(/\n/g, "<br/>") // 转换换行符号
//       .replace(/\r/g, "") //转换回车符号
//     )
//     : html;
// }


// WEBPACK FOOTER //
// ./src/utils/eacapr.js